/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartAreaV = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m14.155 1.43 4.293 6.44L22 4.825V22H2V1.89l6.432 5.262zM4 6.11v13.889h16V9.173l-.434.372-5.551 4.76zm9.844-1.54L9.988 8.426l3.996 3.269 2.934-2.515z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartAreaV as ChartAreaV };
